import { HttpErrorResponse } from '@angular/common/http';
import { of, throwError } from 'rxjs';

export abstract class AbstractDataService {
  /**
   * Look for a 404 and turn it into a NULL.
   */
  protected handleNotFound(error: HttpErrorResponse) {
    if (error.status === 404) {
      return of(null);
    }

    return throwError('Unable to load church unit.');
  }

  /**
   * Look for a 400+ error and if found, return the server's message; otherwise return the
   * generic message we get.
   */
  protected handleBadRequest(genericMessage: string = 'An error occurred') {
    return (error: HttpErrorResponse) => {
      if (error.status >= 400 && error.status < 500 && typeof error.error === 'string') {
        return throwError(error.error);
      }

      return throwError(genericMessage);
    };
  }
}
